module.exports = __webpack_public_path__ + "static/media/улучшенный_мини.fdc60a4d.jpg";